<!-- Botón "Volver" flotante para móviles -->
@if (showBackButton) {
  <button
    type="button"
    class="md:hidden fixed bottom-4 left-4 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-white/20 dark:bg-surface-800/20 backdrop-blur-lg border border-[#4EA1AF] shadow-lg hover:bg-green-100/50 dark:hover:bg-green-900/50 transition-colors duration-200"
    (click)="onBack()"
    aria-label="Volver"
  >
    <i class="pi pi-arrow-left text-2xl text-[#4EA1AF] dark:text-[#4EA1AF]"></i>
  </button>
}

<!-- Breadcrumb personalizado -->
<div class="mb-4">
  <div class="max-w-full px-2 py-1 bg-white dark:bg-surface-900 text-gray-800 dark:text-gray-200 shadow-sm rounded-2xl overflow-hidden">
    <p-breadcrumb [model]="items">
      <ng-template pTemplate="item" let-item let-index="index">
        @if (item.routerLink && index !== items.length - 1) {
          <a class="p-breadcrumb-item-link cursor-pointer" [routerLink]="item.routerLink">
            @if (item.icon) {
              <span [ngClass]="item.icon" class="mr-2"></span>
            }
            <span class="hover:underline font-semibold" style="color: #4EA1AF">
              {{ item.label }}
            </span>
          </a>
        } @else {
          <span>{{ item.label }}</span>
        }
      </ng-template>
    </p-breadcrumb>
  </div>
</div>

<!-- Título + Subtítulo opcional -->
<div class="relative flex items-center justify-between mb-4 mt-4 px-2 border-b-2 border-[#4EA1AF] min-h-[3.5rem] pb-2">
  <!-- Izquierda: botón volver -->
  <div class="flex items-center gap-3 z-10">
    @if (showBackButton) {
      <button
        type="button"
        class="hidden md:flex items-center justify-center w-10 h-10 rounded-full hover:bg-green-100 dark:hover:bg-green-900/50 transition-colors duration-200"
        (click)="onBack()"
        [pTooltip]="backLabel"
        tooltipPosition="top"
      >
        <i class="pi pi-arrow-left text-xl text-[#4EA1AF] dark:text-[#4EA1AF]"></i>
      </button>
    }
  </div>
  <!-- Centro: título absolutamente centrado respecto al contenedor completo -->
  <div class="absolute inset-0 flex flex-col items-center justify-center text-center pointer-events-none">
    <h2
      class="text-3xl text-[#4EA1AF] dark:text-[#4EA1AF] tracking-tight global-header-title pb-1"
    >
      {{ titulo }}
    </h2>
  </div>
  <!-- Derecha: logo -->
  <div class="hidden md:flex items-center z-10">
    <app-img [src]="headerLogoUrl || 'assets/images/icons/logo_original_200w.png'" [width]="200" [height]="72" alt="Brand Logo" [priority]="true" imgClass="w-[120px] md:w-[150px] h-auto"></app-img>
  </div>
</div>
@if (subtitulo) {
  <p class="italic text-md text-gray-500 dark:text-gray-400 mb-4 text-center">{{ subtitulo }}</p>
}

<!-- Botón global "Volver" - Comentado para moverlo junto al título -->
<!-- @if (showBackButton) {
  <div class="ghb-container" aria-live="polite">
    <button type="button" class="ghb-btn" (click)="onBack()" aria-label="{{ backLabel }}">
      <span class="ghb-content">
        <i class="pi pi-arrow-left mr-2"></i>
        <span>{{ backLabel }}</span>
      </span>
    </button>
  </div>
} -->
